export const memes = [
  {
    id: "m1",
    title: "我先走了你随意",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20yellow%20emoji%20face%20waving%20goodbye%20with%20a%20tiny%20suitcase%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-01&orientation=squarish",
    category: "work",
    categoryName: "打工人日常",
    likes: 48200,
    usage: "适合下班、退出群聊、拒绝加班时使用。",
  },
  {
    id: "m2",
    title: "听完陷入沉默",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20orange%20emoji%20face%20with%20wide%20empty%20eyes%20and%20a%20flat%20mouth%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-02&orientation=squarish",
    category: "meme",
    categoryName: "表情包",
    likes: 41900,
    usage: "遇到离谱发言、AI 翻唱、听不懂的梗时使用。",
  },
  {
    id: "m3",
    title: "这图我存了",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20lime%20green%20emoji%20face%20holding%20a%20tiny%20picture%20frame%20with%20both%20hands%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-03&orientation=squarish",
    category: "meme",
    categoryName: "表情包",
    likes: 38600,
    usage: "看到好图、收藏素材、保存表情包时使用。",
  },
  {
    id: "m4",
    title: "机器人也想接梗",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20small%20cute%20robot%20head%20with%20sparkling%20eyes%20and%20a%20question%20mark%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-04&orientation=squarish",
    category: "ai",
    categoryName: "AI 玩梗",
    likes: 32400,
    usage: "AI 生成翻车、机器答非所问时使用。",
  },
  {
    id: "m5",
    title: "神评已被我截屏",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20pink%20emoji%20face%20holding%20a%20phone%20taking%20a%20screenshot%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-05&orientation=squarish",
    category: "comment",
    categoryName: "评论神评",
    likes: 29800,
    usage: "评论区出现金句、神补刀时使用。",
  },
  {
    id: "m6",
    title: "土味情话攻击",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20emoji%20face%20shooting%20tiny%20red%20hearts%20from%20its%20mouth%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-06&orientation=squarish",
    category: "recreate",
    categoryName: "二创二改",
    likes: 26700,
    usage: "被土味情话突袭、想要反击时使用。",
  },
  {
    id: "m7",
    title: "翻车现场记录中",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20emoji%20face%20tipping%20over%20with%20confetti%20and%20motion%20lines%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-07&orientation=squarish",
    category: "hot",
    categoryName: "热梗追踪",
    likes: 24100,
    usage: "模仿失败、直播翻车、社死瞬间时使用。",
  },
  {
    id: "m8",
    title: "热度已过请勿催更",
    image:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20round%20blue%20gray%20emoji%20face%20yawning%20next%20to%20a%20tiny%20hourglass%2C%20warm%20cream%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=600&height=600&seq=chigua-meme-08&orientation=squarish",
    category: "hot",
    categoryName: "热梗追踪",
    likes: 21500,
    usage: "梗已经过气、被催更、想摆烂时使用。",
  },
];